const d = [
    {
        type: 'Feature',
        properties: {
            unique_id: '410311001',
            ext_path: '河南省 洛阳市 洛龙区 安乐路街道',
            cid: '1',
            pid: '410311',
            name: '安乐路街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.470893, 34.657018]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410311102',
            ext_path: '河南省 洛阳市 洛龙区 安乐镇',
            cid: '2',
            pid: '410311',
            name: '安乐镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.479563, 34.648329]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410311003',
            ext_path: '河南省 洛阳市 洛龙区 白马寺镇',
            cid: '3',
            pid: '410311',
            name: '白马寺镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.563711, 34.720523]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410311199',
            ext_path: '河南省 洛阳市 洛龙区 佃庄镇',
            cid: '4',
            pid: '410311',
            name: '佃庄镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.607162, 34.684009]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410311200',
            ext_path: '河南省 洛阳市 洛龙区 丰李镇',
            cid: '5',
            pid: '410311',
            name: '丰李镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.348199, 34.542327]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410311006',
            ext_path: '河南省 洛阳市 洛龙区 古城街道',
            cid: '6',
            pid: '410311',
            name: '古城街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.410752, 34.58365]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410311004',
            ext_path: '河南省 洛阳市 洛龙区 关林街道',
            cid: '7',
            pid: '410311',
            name: '关林街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.483965, 34.607298]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410311002',
            ext_path: '河南省 洛阳市 洛龙区 开元路街道',
            cid: '8',
            pid: '410311',
            name: '开元路街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.437919, 34.633136]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410311194',
            ext_path: '河南省 洛阳市 洛龙区 寇店镇',
            cid: '9',
            pid: '410311',
            name: '寇店镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.654378, 34.547133]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410311196',
            ext_path: '河南省 洛阳市 洛龙区 李村镇',
            cid: '10',
            pid: '410311',
            name: '李村镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.595891, 34.580777]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410311107',
            ext_path: '河南省 洛阳市 洛龙区 李楼镇',
            cid: '11',
            pid: '410311',
            name: '李楼镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.542234, 34.655614]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410311009',
            ext_path: '河南省 洛阳市 洛龙区 龙门街道',
            cid: '12',
            pid: '410311',
            name: '龙门街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.460652, 34.582062]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410311003',
            ext_path: '河南省 洛阳市 洛龙区 龙门石窟街道',
            cid: '13',
            pid: '410311',
            name: '龙门石窟街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.472818, 34.559127]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410311197',
            ext_path: '河南省 洛阳市 洛龙区 庞村镇',
            cid: '14',
            pid: '410311',
            name: '庞村镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.650825, 34.632703]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410311005',
            ext_path: '河南省 洛阳市 洛龙区 太康东路街道',
            cid: '15',
            pid: '410311',
            name: '太康东路街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.492817, 34.626846]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410311016',
            ext_path: '河南省 洛阳市 洛龙区 镇北路街道',
            cid: '16',
            pid: '410311',
            name: '镇北路街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.480498, 34.614529]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410311195',
            ext_path: '河南省 洛阳市 洛龙区 诸葛镇',
            cid: '17',
            pid: '410311',
            name: '诸葛镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.536586, 34.569418]
        }
    }
];

export { d };
